export const environment = {
  production: true,
  backendUrl: 'https://api.budgetsense.app'
};
